module.exports = __webpack_public_path__ + "static/media/computerBroken.8e31a431.gif";